import script from "./callList.vue?vue&type=script&setup=true&lang=js"
export * from "./callList.vue?vue&type=script&setup=true&lang=js"

import "./callList.vue?vue&type=style&index=0&id=7239ee01&scoped=true&lang=css"

import exportComponent from "D:\\WORK_At_Home\\kaikbSource\\restaurant-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7239ee01"]])

export default __exports__